import type { RequestStatusColorType } from './AdministrationPcapRequests.types';

export const getStatusColor = (status: RequestStatusColorType) => {
  switch (status) {
    case 'pending':
      return 'warning';
    case 'completed':
      return 'success';
    case 'failed':
      return 'error';
    default:
      return 'default';
  }
};

export default getStatusColor;
